import { RouterProvider } from 'react-router-dom'
import { router } from './index'

// Composant wrapper pour le routing
export const AppRouter: React.FC = () => {
  return <RouterProvider router={router} />
}

export default AppRouter
